export enum SummaryImportTypes {
    GET_FILTERS = '@@SummaryImport/GET_FILTERS ',
    GET_FILTERS_SUCCESS = '@@SummaryImport/GET_FILTERS_SUCCESS ',
    GET_FILTERS_ERROR = '@@SummaryImport/GET_FILTERS_ERROR ',
    GET_FILTER_LIST = '@@SummaryImport/GET_FILTER_LIST',
    GET_FILTER_LIST_SUCCESS = '@@SummaryImport/GET_FILTER_LIST_SUCCESS',
    GET_FILTER_LIST_ERROR = '@@SummaryImport/GET_FILTER_LIST_ERROR',
  }
  